import img from "../../assets/servicesCard.webp";
import { IoIosArrowDown } from "react-icons/io";

export default function Banner() {
	return (
		<div className="relative w-full min-h-[40vh] flex items-center justify-center overflow-hidden bg-slate-900">
			<div className="absolute inset-0 w-full h-full">
				<div
					className="w-full h-full bg-cover bg-center bg-fixed"
					style={{ backgroundImage: `url(${img})` }}
					role="img"
				/>
				<div className="absolute inset-0 bg-black/50" />
			</div>
			<div className="relative items-center flex flex-col text-white text-center gap-5 top-20">
				<h1 className=" font-semibold text-7xl">Servicios</h1>
				<IoIosArrowDown size={50} />
			</div>
		</div>
	);
}
